import { create } from "../../../common/utils/zustand_state_manager";
import { IReportsRepository } from "../../../features/reports/domain/repositories/reports_repository";
import { ReportsRepository } from "../../../features/reports/data/repositories/reports_repository";
import { useReportsServices } from "./use_services";

/**
 * useReportsRepositories
 */

type State = {
  reportsRepository: IReportsRepository,
};

export const useReportsRepositories = create<State>((set, get) => {
  const { reportsService } = useReportsServices.getState();
  return ({
    reportsRepository: new ReportsRepository(reportsService),
  });
});